import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import {
  create_assessment_kit_action,
  delete_assessment_kit_by_id_data_action,
  create_assessment_kit_skills_action,
  delete_assessment_kit_skill_by_id_data_action,
  get_assessment_kit_by_id_data_action,
  update_assessment_kit_action,
  update_assessment_kit_skill_action,
  get_skill_topics_data_action,
  get_assessment_custom_questions_data_action,
  create_assessment_custom_question_action,
  delete_assessment_custom_question_action,
  update_assessment_custom_question_action,
} from "../../../redux/_actions/";
import { showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";
import { appRoutes } from "../../../_routes/app-routes";
import { skillsConstantsData } from "../../../_constants/AssessmentSkillsConst";
import { questionNumCount } from "../../../_constants/AssessmentConst";
function useNewCreateAssessment() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const [saveLoading, setSaveLoading] = useState(false);
  const [isAssessmentLoading, setIsAssessmentLoading] = useState(false);
  const [saveTypeLoading, setSaveTypeLoading] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [addSkillLoading, setAddSkillLoading] = useState(false);
  const [deleteSkillLoading, setDeleteAddSkillLoading] = useState(false);
  const [deleteSkillId, setDeleteAddSkillId] = useState(null);
  const [assessmentId, setAssessmentId] = useState("");
  const [continueLoading, setContinueLoading] = useState(false);
  const [taggedSkills, setTaggedSkills] = useState([]);
  const [isDeleteAssessmentKitModal, setIsDeleteAssessmentKitModal] =
    useState(false);
  const [formData, setFormData] = useState({});
  const [customQuestionFormData, setCustomQuestionFormData] = useState({});
  const [customQuestionData, setCustomQuestionData] = useState([]);
  const [skillsData, setSkillsData] = useState([]);
  const [skillsData2, setSkillsData2] = useState([]);
  const [isDeleteCustomQuestionModal, setIsDeleteCustomQuestionModal] =
    useState(false);
  const [deleteCustomQuestionLoading, setDeleteCustomQuestionLoading] =
    useState(false);
  const [customQuestionsData, setCustomQuestionsData] = useState([]);
  const [customQuestionEditId, setCustomQuestionEditId] = useState(null);
  const [isAddCustomQuestion, setIsAddCustomQuestion] = useState(false);
  const [skillTopics, setSkillTopics] = useState([]);
  const [customSelectedSkill, setCustomSelectedSkill] = useState(null);
  const [customSelectedTopic, setCustomSelectedTopic] = useState(null);
  const [customQuestionDeleteId, setCustomQuestionDeleteId] = useState(null);
  const [isSaveQuestionLoading, setIsSaveQuestionLoading] = useState(false);

  const { createAssessmentData } = useSelector(
    (state) => state.create_assessment_kit_reducer
  );
  const { skillTopicsData } = useSelector(
    (state) => state.get_skill_topics_data_reducer
  );

  const { allCustomQuestionsData } = useSelector(
    (state) => state.get_assessment_custom_questions_data_reducer
  );

  useEffect(() => {
    window.scroll(0, 0);
    let id = params?.id;
    setAssessmentId(id);
    setFormData({});
    setSkillsData(skillsConstantsData);
 
  }, []);

  useEffect(() => {
    if (assessmentId) {
      callApi(assessmentId);
      getCustomQuestions(assessmentId);
    } else {
      setFormData({});
    }
  }, [assessmentId]);

  useEffect(() => {
    if (skillTopicsData) {
      setSkillTopics(skillTopicsData);
    }
  }, [skillTopicsData]);

  useEffect(() => {
    if (allCustomQuestionsData) {
      setCustomQuestionsData(allCustomQuestionsData);
    }
  }, [allCustomQuestionsData]);

  useEffect(() => {
    if (createAssessmentData) {
      existingSkillRemoveHandler();
      setFormData(createAssessmentData);
    }
  }, [createAssessmentData]);

  const callApi = async (id) => {
    setIsAssessmentLoading(true);
    await dispatch(get_assessment_kit_by_id_data_action(id));
    setIsAssessmentLoading(false);
  };
  const onSaveClick = async (status) => {
    const data = {
      status: status,
      title: formData?.title,
      additional_notes: formData?.additional_notes,
      total_questions: questionNumCount,
    };
    if (formData?.title === "" || formData?.title === undefined) {
      showWarningMessage("Please enter title!");
      return;
    }
    setSaveLoading(true);
    setSaveTypeLoading(status);
    if (formData?.id) {
      await dispatch(update_assessment_kit_action(data, formData?.id));

      if (status === "publish" || status === "archived") {
        navigate(appRoutes.assessementKit.allAssessments);
      }
    } else {
      const res = await dispatch(create_assessment_kit_action(data));
      if (res?.id) {
        navigate(
          appRoutes.assessementKit.viewAssessment.replace(":id", res?.id)
        );
        setAssessmentId(res?.id);
      }
    }

    setSaveLoading(false);
    setSaveTypeLoading(null);
  };

  const onBlur = (e) => {
    let formDataNew = formData;
    const name = e.target.name;
    const value = e.target.value;
    formDataNew[name] = value;
    setFormData(formDataNew);
  };

  const onUpdateAssessmentKitSkill = async (e, skill) => {
    const value = e.target.value;
    const id = skill?.id;

    if (formData?.id) {
      const data = {
        difficulty_level: value,
      };
      const res = await dispatch(update_assessment_kit_skill_action(data, id));
      if (res) {
        await dispatch(get_assessment_kit_by_id_data_action(formData?.id));
      }
    }
  };

  const onSkillSearch = async (e) => {
    let [id, skill] = e.split(",");
    if (formData?.id) {
      const checkExistingSkill =
        formData?.skills &&
        formData?.skills.some(
          (item) => item?.skill_id && item?.skill_id?.id === Number(id)
        );
      if (checkExistingSkill) {
        showWarningMessage("Skill Already Exists !");
      } else {
        const data = {
          assessment_id: formData?.id,
          skill_id: Number(id),
          difficulty_level: "beginner",
        };
        setAddSkillLoading(true);
        const res = await dispatch(create_assessment_kit_skills_action(data));
        if (res) {
          await dispatch(get_assessment_kit_by_id_data_action(formData?.id));

          setAddSkillLoading(false);
        }
      }
    }
  };
  const handleIsDeleteAssessmentModal = () => {
    setIsDeleteAssessmentKitModal(!isDeleteAssessmentKitModal);
  };
  const onDeleteAssessment = async (id) => {
    setDeleteLoading(true);
    await dispatch(delete_assessment_kit_by_id_data_action(id));
    setDeleteLoading(false);
    navigate(appRoutes.assessementKit.allAssessments);
  };
  const onDeleteAssessmentSkill = async (id) => {
    setDeleteAddSkillId(id);
    setDeleteAddSkillLoading(true);
    const res = await dispatch(
      delete_assessment_kit_skill_by_id_data_action(id)
    );
    if (res) {
      await dispatch(get_assessment_kit_by_id_data_action(formData?.id));
      setDeleteAddSkillId(null);
      setDeleteAddSkillLoading(false);
    }
  };
  const existingSkillRemoveHandler = () => {
    const getNewData =
      Array.isArray(createAssessmentData && createAssessmentData?.skills) &&
      createAssessmentData &&
      createAssessmentData?.skills
        ? createAssessmentData && createAssessmentData?.skills
        : [];
    const idsToRemove = new Set(
      getNewData.map((item) => item?.skill_id && item?.skill_id?.id)
    );
    const filteredSkills =
      Array.isArray(skillsConstantsData) &&
      skillsConstantsData.filter((element) => !idsToRemove.has(element.id));
    setSkillsData(filteredSkills);
  };

  const onChangeCustomQuestionInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    let data = customQuestionFormData;

    if (name === "time_to_answer_in_minutes" || name === "topic_id") {
      data[name] = Number(value);
    } else {
      data[name] = value;
    }
  };

  const validateCustomQuestionForm = (data) => {
    if (!data?.question_text || data?.question_text === "") {
      showWarningMessage("Please enter Question ");
    } else if (
      !data?.time_to_answer_in_minutes ||
      data?.time_to_answer_in_minutes === ""
    ) {
      showWarningMessage("Please Enter Time to Answer the question");
    } else if (isNaN(data?.time_to_answer_in_minutes)) {
      showWarningMessage("Please enter valid time");
    } else if (!data?.difficulty_level || data?.difficulty_level === "") {
      showWarningMessage("Please select difficulty level");
    } else if (!data?.skill_id || data?.skill_id === "") {
      showWarningMessage("Please Select Skill");
    } else if (!data?.topic_id || data?.topic_id === "") {
      showWarningMessage("Please Select Topic");
    } else {
      return true;
    }
  };
  const onSaveCustomQuestion = async (type, id) => {
    const data = {
      question_text: customQuestionFormData?.question_text,
      time_to_answer_in_minutes:
        customQuestionFormData?.time_to_answer_in_minutes,
      difficulty_level: customQuestionFormData?.difficulty_level,
      skill_id: customQuestionFormData?.skill_id,
      topic_id: customQuestionFormData?.topic_id,
    };

    if (type === "create") {
      data["assessment_id"] = Number(assessmentId);
      data["status"] = "pending";
    }
    if (validateCustomQuestionForm(data)) {
      if (type === "create") {
        setIsSaveQuestionLoading(true);
        const res = await dispatch(
          create_assessment_custom_question_action(data)
        );
        if (res?.assessment_id && res?.assessment_id?.id) {
          getCustomQuestions(res?.assessment_id && res?.assessment_id?.id);
          onCancelCustomQuestion();
        }
        setIsSaveQuestionLoading(false);
      } else {
        setIsSaveQuestionLoading(true);

        const res = await dispatch(
          update_assessment_custom_question_action(data, id)
        );
        setIsSaveQuestionLoading(false);

        if (res?.id) {
          await dispatch(
            get_assessment_custom_questions_data_action(assessmentId)
          );
          onCancelCustomQuestion();
        }
      }
    }
  };
  const onCustomQuestionSearchSelect = async (e) => {
    let [id, skill] = e.split(",");
    setCustomSelectedSkill(skill);
    const data = customQuestionFormData;
    data["skill_id"] = Number(id);
    setCustomQuestionFormData(data);
    await dispatch(get_skill_topics_data_action(Number(id)));
  };

  const handleIsDeleteCustomQuestionModal = (id) => {
    setIsDeleteCustomQuestionModal(!isDeleteCustomQuestionModal);
    setCustomQuestionDeleteId(id);
  };

  const onDeleteCustomQuestion = async () => {
    setDeleteCustomQuestionLoading(true);
    if (customQuestionDeleteId) {
      const res = await dispatch(
        delete_assessment_custom_question_action(customQuestionDeleteId)
      );
      if (res) {
        await dispatch(
          get_assessment_custom_questions_data_action(formData?.id)
        );
        setIsDeleteCustomQuestionModal(false);
      }
    }
    setDeleteCustomQuestionLoading(false);
  };

  const getCustomQuestions = async (id) => {
    await dispatch(get_assessment_custom_questions_data_action(id));
  };
  const onEditCustomQuestion = async (item, id) => {
    setSkillsData2(skillsConstantsData);
    setCustomQuestionFormData({});

    setCustomQuestionEditId(id);
    const data = {
      question_text:
        item?.question_bank_question_id &&
        item?.question_bank_question_id?.question_text,
      time_to_answer_in_minutes:
        item?.question_bank_question_id &&
        item?.question_bank_question_id?.time_to_answer_in_minutes,
      difficulty_level:
        item?.question_bank_question_id &&
        item?.question_bank_question_id?.difficulty_level,
      skill_id:
        item?.question_bank_question_id &&
        item?.question_bank_question_id?.skill_id &&
        item?.question_bank_question_id?.skill_id?.id,
      topic_id:
        item?.question_bank_question_id &&
        item?.question_bank_question_id?.topic_id &&
        item?.question_bank_question_id?.topic_id?.id,
    };
    setCustomSelectedSkill(
      item?.question_bank_question_id &&
        item?.question_bank_question_id?.skill_id &&
        item?.question_bank_question_id?.skill_id?.skill
    );

    setCustomSelectedTopic(
      item?.question_bank_question_id &&
        item?.question_bank_question_id?.topic_id &&
        item?.question_bank_question_id?.topic_id?.topic_name
    );

    await dispatch(
      get_skill_topics_data_action(
        item?.question_bank_question_id &&
          item?.question_bank_question_id?.skill_id &&
          item?.question_bank_question_id?.skill_id?.id
      )
    );
    setCustomQuestionFormData(data);
  };
  const onCancelCustomQuestion = () => {
    setCustomQuestionEditId(null);
    setCustomQuestionFormData(false);
    setIsAddCustomQuestion(false);
    setCustomSelectedSkill(null);
    setCustomSelectedTopic(null);
    setCustomQuestionDeleteId(null);
  };

  const addCustomQuestion = () => {
    setSkillsData2(skillsConstantsData);
    setIsAddCustomQuestion(true);
  };

  const onChangeSelect = (value, name, label) => {
    let data = customQuestionFormData;
    if (name === "topic_id") {
      data[name] = Number(value);
      if (label) setCustomSelectedTopic(label);
    } else {
      data[name] = value;
    }
    setCustomQuestionFormData(data);
  };

  return {
    saveLoading,
    continueLoading,
    formData,
    taggedSkills,
    isDeleteAssessmentKitModal,
    deleteLoading,
    addSkillLoading,
    deleteSkillLoading,
    deleteSkillId,
    skillsData,
    skillsData2,
    saveTypeLoading,
    isAssessmentLoading,
    customQuestionData,
    isDeleteCustomQuestionModal,
    customSelectedSkill,
    isSaveQuestionLoading,
    customSelectedTopic,
    customQuestionsData,
    customQuestionEditId,
    customQuestionFormData,
    isAddCustomQuestion,
    skillTopics,
    deleteCustomQuestionLoading,
    onChangeCustomQuestionInput,
    onChangeSelect,
    onBlur,
    onSaveClick,
    onUpdateAssessmentKitSkill,
    onDeleteAssessment,
    onDeleteAssessmentSkill,
    onSkillSearch,
    handleIsDeleteAssessmentModal,
    onSaveCustomQuestion,
    onCustomQuestionSearchSelect,
    handleIsDeleteCustomQuestionModal,
    onDeleteCustomQuestion,
    onEditCustomQuestion,
    onCancelCustomQuestion,
    addCustomQuestion,
  };
}

export default useNewCreateAssessment;
